module.exports = __webpack_public_path__ + "img/info-icon.d06308a1.svg";